<template>
  <div class="mobMegamenu__main">
    <div class="background__holder">
      <div class="main">
        <div class="mobilemegamenu__main">
          <a-menu
            mode="inline"
            :open-keys="openKeys"
            style="width: 100%"
            @openChange="onOpenChange"
          >
            <a-sub-menu v-for="menu in allMenus" :key="menu.index">
              <span slot="title"
                ><span>{{ menu.name }}</span></span
              >

              <a-sub-menu
                :title="submenu.name"
                v-for="submenu in menu.submenus"
                :key="submenu.id"
              >
                <a-menu-item
                  v-for="category in submenu.category_info.slice(0, 5)"
                  :key="category.id"
                >
                  <div>
                    <div class="mobilemega__menuItems">
                      <img
                        :src="
                          category.image
                            ? category.image
                            : require('../../assets/cuisines/no_image.jpg')
                        "
                        :alt="category.name"
                      />
                      <span
                        @click="
                          getSubmenu(
                            menu.name,
                            menu.id,
                            submenu.id,
                            category.id
                          );

                          $emit('onClose', false);
                        "
                      >
                        {{ category.name }}
                      </span>
                    </div>
                  </div>
                </a-menu-item>

                <a-menu-item
                  @click="
                    $emit('onClose', false);
                    onCategories(menu.name);
                    getMenuId(menu.name);
                  "
                >
                  Expand
                </a-menu-item>
              </a-sub-menu>
              <a-menu-item
                @click="
                  $emit('onClose', false);
                  getMenuIds(menu);
                "
              >
                Expand
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
import { LocationId } from "../../services/storage.service";

export default {
  name: "MobileMegaMenu",
  props: ["menu"],

  data() {
    return {
      rootSubmenuKeys: [
        "sub1",
        "sub6",
        "sub7",
        "sub8",
        "sub9",
        "sub10",
        "sub11",
      ],
      openKeys: ["sub2"],
      windowWidth: null,
      success: false,
    };
  },
  created() {
    this.checking();
  },
  computed: {
    ...mapGetters(["allMenus"]),
  },
  methods: {
    ...mapActions(["getMenuId"]),

    getSubmenu(menuName, menuId, subMenuId, catId) {
      if (LocationId.getLocationId() == 1) {
        // router.push("/ktm/c/" + submenu.name);
        router.push(`/ktm/c/${menuName}/${menuId}/${subMenuId}/${catId}`);
      } else if (LocationId.getLocationId() == 2) {
        // router.push("/pkr/c/" + submenu.name);
        router.push(`/pkr/c/${menuName}/${menuId}/${subMenuId}/${catId}`);
      }
    },

    getMenuIds(menu) {
      // alert(submenu);
      // const submenu = this.menu;
      if (LocationId.getLocationId() == 1) {
        // router.push("/ktm/c/" + submenu.name);
        router.push(`/ktm/c/${menu.name}/${menu.id}`);
      } else if (LocationId.getLocationId() == 2) {
        // router.push("/pkr/c/" + submenu.name);
        router.push(`/pkr/c/${menu.name}/${menu.id}`);
      }
    },

    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },

    onProductFeature() {
      if (LocationId.getLocationId() == 1) {
        router.push("/ktm/k/" + menuName || this.menuIds);
      } else if (LocationId.getLocationId() == 2) {
        router.push("/pkr/k/" + menuName || this.menuIds);
      }
    },

    onCategories(menuName) {
      // alert(menuName)
      if (LocationId.getLocationId() == 1) {
        router.push("/ktm/k/" + menuName || this.menuIds);
      } else if (LocationId.getLocationId() == 2) {
        router.push("/pkr/k/" + menuName || this.menuIds);
      }
      // window.location.reload();
    },

    onResize() {
      this.windowWidth = window.innerWidth;
      console.log(this.windowWidth);
    },

    // getSubmenu(redirect) {
    //   if (LocationId.getLocationId() == 1) {
    //     router.push("/ktm/c/" + redirect);
    //   } else if (LocationId.getLocationId() == 2) {
    //     router.push("/pkr/c/" + redirect);
    //   }
    // },

    handleSearch(redirect) {
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: redirect },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: redirect },
        });
      }
    },

    onresize() {
      this.windowWidth = window.innerWidth;
      // alert(this.windowWidth)
    },
  },

  mounted() {
    this.onresize();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.mobMegamenu__main {
  position: relative;
}

.background__holder {
  background-color: #dd3300;
}

.ant-menu >>> .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
  color: red;
}

.ant-menu >>> .ant-menu-sub.ant-menu-inline > .ant-menu-item {
  color: #ed3c3b;
}

.mobilemega__menuItems {
  font-family: "Montserrat", sans-serif;
}

.mobilemega__menuItems > img {
  height: 35px;
  width: 35px;
  margin-right: 18px;
  border-radius: 8px;
  object-fit: cover;
}
.mobilemegamenu__main {
  position: absolute;
  z-index: 999999;
  /* top: 0%; */
  width: 99vw;
}

.main {
  position: absolute;
  z-index: 999999;
  background-image: url(../../assets/background/footer.png);
}
</style>
